import './actifsplus.scss';

// Chargement de alpine
import Alpine from "@alpinejs/csp";
window.Alpine = Alpine;

import {ap_bootstrapAlpineFormComponents, ap_setupForm} from "./js/alpineFormHelper";

import lookupOrganization from './js/lookupOrganization';
import registerCustomerStore from "./pages/registerCustomer/registerCustomerStore";
import registerCustomerForm from "./pages/registerCustomer/registerCustomerForm";


console.log("Starting Alpine");
// Chargement des composants communs de la couche formulaire
ap_bootstrapAlpineFormComponents()

// Setup spécifique du formulaire
ap_setupForm({
    debug: true,

    store: {
        name: 'registerCustomerForm',
        callback: registerCustomerStore,
        params: { sfFieldNameSuffix :  'register_customer'}
    },

    form: {
        name: 'registerCustomerForm',
        callback: registerCustomerForm,
    },

    components: [
        { name: 'organizationLookup', instance: lookupOrganization }
    ]
})

Alpine.start();
console.log("Alpine started");




